import { Avatar } from "@mui/material";
import GroupsIcon from "@mui/icons-material/Groups";
import PersonIcon from "@mui/icons-material/Person";

const AVATAR_GREY = "#bdbdbd";

/**
 * A blank grey person for a provider; with no `provider`, the „Bárki” disc, a group in the same
 * grey. Neutral on every theme, so it needs nothing from the tenant's colours.
 * `provider.imageUrl` is empty for everyone today, so no photo is drawn (docs/MULTI_PROVIDER.md).
 */
const ProviderAvatar = ({ provider, size = 56 }) => {
  const Glyph = provider ? PersonIcon : GroupsIcon;

  return (
    <Avatar sx={{ width: size, height: size, color: "#fff", backgroundColor: AVATAR_GREY }}>
      <Glyph sx={{ fontSize: size * (provider ? 0.7 : 0.55) }} />
    </Avatar>
  );
};

export default ProviderAvatar;
